export const COMPONENT_NAME = 'Records';
